import React, { useEffect } from "react";
import { Button, Card, Tag } from "antd";
import { FileText, User, Crown, Shield, Building, Check, Lock, X } from "lucide-react";
import "./SummaryTab.css";


const SummaryTab = ({ userData = {},
    currentUserData = {},
    accessContents = [],
    subscriptionPlans = [], roles = [],
    onStepComplete = () => { } }) => {
    const planNames = { basic: "Basic Plan", pro: "Pro Plan", business: "Business Plan" };

    const [mergedUserData, setMergedUserData] = React.useState({});
    const [brandsWithAccess, setBrandsWithAccess] = React.useState([]);
    const [selectedPlan, setSelectedPlan] = React.useState(null);
    const [selectedRoles, setSelectedRoles] = React.useState([]);

    useEffect(() => {
        const newData = { ...userData, ...currentUserData };
        if (JSON.stringify(newData) !== JSON.stringify(mergedUserData)) {
            setMergedUserData(newData);
        }
    }, [userData, currentUserData]);

    useEffect(() => {
        if (!mergedUserData)
            return;

        const brands = mergedUserData.accesscontent ? JSON.parse(mergedUserData.accesscontent) : [];
        console.log("brandsWithAccess: " + JSON.stringify(brands));
        setBrandsWithAccess(brands);

        if ("planid" in mergedUserData) {
            const plan = subscriptionPlans.find(plan => plan.planid === mergedUserData.planid);
            console.log("selectedPlan: " + JSON.stringify(plan));
            setSelectedPlan(plan);
        }

        const rolesSelected = (mergedUserData.roleids || []).map(r => roles.find(role => role.userroleid == r)).filter(r => r);

        console.log("rolesSelected: " + JSON.stringify(rolesSelected));
        setSelectedRoles(rolesSelected);
    }, [mergedUserData]);

    // const brandsWithAccess = mergedUserData && mergedUserData.accesscontent ? JSON.parse(mergedUserData.accesscontent) : [];
    // const selectedPlan = subscriptionPlans.find(plan => plan.planid === mergedUserData.planid);
    // const selectedRoles = (mergedUserData.roleids || []).map(r => roles.find(role => role.userroleid == r)).filter(r => r);

    console.log("mergedUserData: " + JSON.stringify(mergedUserData));
    console.log("selectedRoles: " + JSON.stringify(selectedRoles));


    const handleContinue = () => {
        // setUserData({ ...userData, roles: selectedRoles });
        onStepComplete();
    };

    //get username if exists otherwise show "New User"
    //get full name if exists otherwise show "Full Name"
    //if both username and full name exist show "username (Full Name)"
    //if only full name exists show "Full Name"
    //if only username exists show "username"

    var userDisplayName = "New User";
    if (mergedUserData) {
        if (mergedUserData.username && mergedUserData.firstname && mergedUserData.lastname) {
            userDisplayName = `${mergedUserData.username} (${mergedUserData.firstname} ${mergedUserData.lastname})`;
        } else if (mergedUserData.username) {
            userDisplayName = mergedUserData.username;
        } else if (mergedUserData.firstname && mergedUserData.lastname) {
            userDisplayName = `${mergedUserData.firstname} ${mergedUserData.lastname}`;
        }
    }

    return (
        <div className="summary-tab">
            {/* User Overview */}
            <Card
                title={
                    <span className="card-title">
                        <FileText size={16} /> User Summary
                    </span>
                }>
                <div className="summary-grid">
                    <div className="summary-section">
                        <div className="summary-item">
                            <div className="summary-icon">
                                <User size={16} />
                            </div>
                            <div>
                                <div className="summary-text">{userDisplayName}</div>
                                <div className="summary-subtext">{mergedUserData && mergedUserData.email ? mergedUserData.email : "User Name"}</div>
                            </div>
                        </div>
                        <div className="summary-item">
                            <div className="summary-icon">
                                <Crown size={16} />
                            </div>
                            <div>
                                <div className="summary-text">{selectedPlan ? selectedPlan.planname : "-"}</div>
                                <div className="summary-subtext">Subscription Plan</div>
                            </div>
                        </div>
                    </div>

                    <div className="summary-section">
                        <div className="summary-item">
                            <div className="summary-icon">
                                <Shield size={16} />
                            </div>
                            <div>
                                <div className="summary-text">{selectedRoles ? <span>{selectedRoles.map((r) => { return r.userrolename }).join(", ")}</span> : "-"}</div>
                                <div className="summary-subtext">Main Role(s)</div>
                            </div>
                        </div>
                        <div className="summary-item">
                            <div className="summary-icon">
                                <Building size={16} />
                            </div>
                            <div>
                                <div className="summary-text">
                                    {brandsWithAccess.length} Override{brandsWithAccess.length !== 1 ? "s" : ""}
                                </div>
                                <div className="summary-subtext">Brand Overrides</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>

            {/* Brand Permissions Breakdown */}
            <Card className="summary-card">
                <h3 className="card-title">Effective Permissions by Brand</h3>
                <p className="card-subtext">Final permissions applied per brand</p>

                {brandsWithAccess.length === 0 && (
                    <p className="inherit-text">No brand overrides configured. Permissions inherit from main role.</p>
                )}

                {brandsWithAccess.map((brandAccess, index) => {
                    const { brandid, override_permissions } = brandAccess;
                    console.log("Processing brandAccess: " + JSON.stringify(brandAccess));
                    console.log("Processing brandAccess for brandId: " + brandid);
                    const brand = accessContents.find((b) => b.BrandID == brandid);
                    console.log("Found brand data: " + JSON.stringify(brand));
                    const effectivePermissions = override_permissions;
                    const hasOverride = brandAccess ? brandAccess.override_permissions && Object.keys(brandAccess.override_permissions).length : false;

                    if (!brand) {
                        return (
                            <div key={index} className="brand-block">
                                <div className="brand-header">
                                    <div className="brand-info">
                                        <div className="summary-icon">
                                            <Building size={16} />
                                        </div>
                                        <div>
                                            <div className="summary-text">Unknown Brand (ID: {brandid})</div>
                                        </div>
                                    </div>
                                    {hasOverride ? (
                                        <Tag color="blue">Custom Override</Tag>
                                    ) : (
                                        <Tag>{`Inherits from ${selectedRoles ? selectedRoles.map((r) => { return r.userrolename }).join(", ") : "-"}`}</Tag>
                                    )}
                                </div>
                                <p className="error-text">Brand data not found.</p>
                            </div>
                        );
                    }
                    return (
                        <div className="brand-block">
                            {index > 0 && <hr className="separator" />}
                            <div className="brand-header">
                                <div className="brand-info">
                                    <div className="summary-icon">
                                        <Building size={16} />
                                    </div>
                                    <div>
                                        <div className="summary-text">{brand.BrandName}</div>
                                    </div>
                                </div>
                                {hasOverride ? (
                                    <Tag color="blue">Custom Override</Tag>
                                ) : (
                                    <Tag>{`Inherits from ${selectedRoles ? selectedRoles.map((r) => { return r.userrolename }).join(", ") : "-"}`}</Tag>
                                )}
                            </div>

                            {/* ✅ Show selected branches */}
                            {brandAccess?.branches?.length > 0 && (
                                <div className="branches-list">
                                    <strong>Branches:</strong>{" "}
                                    {brandAccess.branches.map(b => {
                                        const branch = brand.Branches.find(branch => branch.BranchID == b);
                                        return <Tag>{branch ? branch.BranchName : `Unknown (ID: ${b})`}</Tag>;
                                    })}
                                </div>
                            )}

                            <div className="permissions-grid">
                                {effectivePermissions && Object.keys(effectivePermissions).length > 0 ? (
                                    Object.keys(effectivePermissions).map((menuName) =>
                                        Object.keys(effectivePermissions[menuName]).map((permissionKey) => (
                                            <div key={`${menuName}_${permissionKey}`} className={`permission ${effectivePermissions[menuName][permissionKey] ? "allowed" : "blocked"}`}>
                                                {
                                                    effectivePermissions[menuName][permissionKey] ?
                                                        <Check size={12} /> : <X size={12} />
                                                }
                                                {" "}
                                                {`${menuName} - ${permissionKey}`}
                                            </div>
                                        ))
                                    )
                                ) : (
                                    <p className="inherit-text">All permissions inherited from main role.</p>
                                )}
                            </div>

                        </div>
                    );
                })}

                {(!userData || Object.keys(userData).length === 0) && <Button type="primary" block onClick={handleContinue}>
                    Confirm and Create User
                </Button>}
            </Card>
        </div>
    );
};

export default SummaryTab;
